import { useOutreachDraft } from '@/entities/outreach-draft';
import { useOutreachOutlierSummary } from '@/entities/outreach-candidate';
import { outlierTotals } from './outlierGroups';

/** 기준·현재가 같으면 화면에서 옮긴 사람이 없다 — 서버가 센 값을 그대로 쓴다. */
const NONE: ReadonlySet<string> = new Set();

/**
 * 이번 초안이 메일을 보낼 **계정** 수 — 아직 못 세었으면 `null`.
 *
 * 퀘스트 `da3f95d4` 본문의 「대상 수를 0명으로 고정해 보인다 — 버그」가 여기서 풀린다. 작성기가
 * 그 수를 몰랐던 것이지 값이 없던 것이 아니다.
 *
 * **클라이언트가 직접 셀 수 없다.** `selectedCountOf` 는 「조건에 맞는 대상 전체 선택」 갈래에서
 * `null` 을 준다(`useCandidateSelection.ts`) — 명단이 스냅샷 안에만 있기 때문이다. 대신 후보
 * 선택 화면 하단이 쓰는 것과 같은 길을 쓴다: 서버 이상치 요약의 `totalCount` 에서 기본으로 빠지는
 * 묶음을 덜어 낸 `outlierTotals(...).send`.
 *
 * 🔴 **계정 수이지 통 수가 아니다.** 같은 주소로 접히는 것은 발송 확인이 센다(`sendCount`).
 *
 * 서버 호출은 안 는다 — 발송 확인이 부르는 것과 같은 쿼리라 캐시가 같은 응답을 준다.
 */
export function useSendableCount(scenarioId: string, country: string | null): number | null {
  // 나라가 없으면(메일 겹이 닫혀 있으면) 아무것도 안 부른다 — `useOutreachDraft` 가 `null` 을 본다.
  const draft = useOutreachDraft(scenarioId, country);
  const summary = useOutreachOutlierSummary(scenarioId, draft.data?.id ?? null);
  if (!summary.data) return null;
  return outlierTotals(summary.data, NONE, NONE).send;
}
